module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="block">\n    <div class="filter-hook"></div>\n    <div class="list-hook"></div>\n    <div class="pagination-hook"></div>\n</div>\n<div class="actions">\n    <a class="button" href="/joinos/joinos_codes/?format=csv&per_page=50000" target="_blank">\n        Export CSV\n    </a>\n    <a class="button button-print">\n        Print Joinos Letters\n    </a>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./joinos_codes/templates/layout.html
// module id = 312
// module chunks = 0